import React, { useState } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')
const all = require('it-all')

export const FolderUpload = ({ setUrl }) => {
    const [files, setFiles] = useState([])
    const [folderUrl, setFolderUrl] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)

    const uploadFiles = async () => {
        let fileObjectsArray = Array.from(files).map((file) => {
            return {
                path: file.name,
                content: file
            }
        })

        const results = await all(
            ipfs.addAll(fileObjectsArray, { wrapWithDirectory: true })
        )

        console.log(results)
        return results
    }

    const returnFilesUrl = async (e) => {
        setLoading(true)
        e.preventDefault()

        const results = await uploadFiles(files)
        const length = results.length
        const FilesHash = results[length - 1].cid._baseCache.get('z')
        const FilesUrl = 'https://ipfs.infura.io/ipfs/' + FilesHash
        console.log(FilesUrl)
        setUrl(FilesUrl)
        setFolderUrl(FilesUrl)
        setLoading(false)
        setUploaded(true)
    }

    const filesAndUploadButton = () => {
        if (files.length !== 0) {
            if (!loading) {
                return (
                    <div>
                        {uploaded ? (
                            <h5>
                                ✅{' '}
                                <a
                                    href={folderUrl}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Folder
                                </a>{' '}
                                Uploaded Successfully ✅
                            </h5>
                        ) : (
                            <div className='mt-3'>
                                <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                                    Upload Folder
                                </button>

                                <ul className='mb-3 mt-3'>
                                    {Array.from(files).map((file) => {
                                        return (
                                            <li
                                                className='d-flex justify-content-between align-items-start'
                                            >
                                                <div className='ms-2 me-auto'>
                                                    {file.name}
                                                </div>
                                                <span className='bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
                                                    {file.size} kb
                                                </span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading Folder</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            }
        }
    }

    return (
        <div>
            <form onSubmit={returnFilesUrl}>
                <input
                    required
                    type='file'
                    webkitdirectory='true'
                    multiple
                    onChange={(e) => setFiles(e.target.files)}
                    className='p-3 text-sm bg-white rounded border-0 focus:outline-none focus:ring shadow transition-all duration-150 ease-linear placeholder:text-blueGray-300 text-blueGray-600'
                />

                {filesAndUploadButton()}
            </form>
        </div>
    )
}
